export const LOAD_MAGIC_SYNC_BLOCKLIST_REQUEST = 'magicSyncBlocklist/LOAD_MAGIC_SYNC_BLOCKLIST_REQUEST';
export const LOAD_MAGIC_SYNC_BLOCKLIST_SUCCESS = 'magicSyncBlocklist/LOAD_MAGIC_SYNC_SUGGESTIONS_SUCCESS';
export const LOAD_MAGIC_SYNC_BLOCKLIST_FAILURE = 'magicSyncBlocklist/LOAD_MAGIC_SYNC_SUGGESTIONS_FAILURE';

export const UPDATE_MAGIC_SYNC_BLOCKLIST_REQUEST = 'magicSyncBlocklist/UPDATE_BLOCKLIST_REQUEST';
export const UPDATE_MAGIC_SYNC_BLOCKLIST_SUCCESS = 'magicSyncBlocklist/UPDATE_BLOCKLIST_SUCCESS';
export const UPDATE_MAGIC_SYNC_BLOCKLIST_FAILURE = 'magicSyncBlocklist/UPDATE_BLOCKLIST_FAILURE';